import OpenAppModal from "@/views/OpenApp.vue";
import { selectHotel, listHotels } from "@/service/cas.js";
import { open } from "@/libs/common.js";
export default {
  data() {
    return {
      unitIsNone: false,
      showModal: false,
      downLoadUrl: "",
      units: [],
      search: ""
    };
  },
  components: {
    OpenAppModal
  },
  methods: {
    async getListHotels() {
      const res = await listHotels(this.search);
      if (res.data && res.data.result === 0) {
        var _res$data;
        this.units = (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.retVal) === null || _res$data === void 0 ? void 0 : _res$data.datas;
      }
    },
    // async onSearch() {
    //   this.getListHotels();
    // },
    show(units, appCode, downLoadUrl) {
      this.search = "";
      this.showModal = true;
      this.units = units;
      this.appCode = appCode;
      this.downLoadUrl = downLoadUrl;
    },
    async checkUnit(item) {
      var _res$data2;
      const res = await selectHotel({
        hotelCode: item.code,
        appCode: this.appCode
      });
      open(`${this.appCode}://?token=${(_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.retVal}`);
      this.showModal = false;
    }
  }
};